const n = {
  Internal: "INTERNAL",
  External: "EXTERNAL"
};
export {
  n as o
};
//# sourceMappingURL=PaymentMethod-f2ce08ce.mjs.map
